<template>
  <!-- Scroll START -->
  <div v-bar class="scrollable__wrapper">
    <div class="scrollable">
      <slot></slot>
    </div>
  </div>
  <!-- // Scroll END -->
</template>

<script>
  export default {
    name: 'scroller',

    data: function () {
      return {

      }
    },

    methods: {

    }
  }
</script>

<style lang="less" scoped>
  .scrollable::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// Scroller.vue?813503a6